<template>
  <div>
    <div class="container">
      <h5 class="mt-2">
        Selecione as OS's que deseja imprimir para este documento:
      </h5>
      <b-row class="mt-3">
        <b-col cols="6">
          <b-row class="bold text-center">
            <b-col cols="2" />
            <b-col>OS</b-col>
            <b-col>Quantidade</b-col>
            <b-col>Valor</b-col>
          </b-row>
          <b-row v-for="(os, index) in ordemServico"
                 :key="os.ordem_servico_id+'_'+index"
                 class="text-center mt-2">
            <b-col cols="2">
              <b-form-checkbox :id="`checkbox_os_${index}`"
                               v-model="selected"
                               switch
                               :value="os"
                               :checked="index == ordemServico.length -1 ? [os] : [] "
                               @change="selectOrdemServico(os)"
                               @keyup.native.enter="selectOrdemServico(os)" />
            </b-col>
            <b-col>OS {{ os.numero }}</b-col>
            <b-col>{{ os.itens && filterItensBySelo(os.itens).length ? filterItensBySelo(os.itens).reduce((a, item) => a + item.quantidade, 0) : 0 }}</b-col>
            <b-col>{{ centsToReal(os.valor_total) }}</b-col>
          </b-row>
          <b-row v-if="ordemServico && ordemServico.length == 0">
            <b-col class="text-center">
              <span class="mt-2">Nenhuma ordem de serviço cadastrada</span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <hr>
    <div class="text-right">
      <button class="btn btn-sm btn-default mr-2">
        Voltar
      </button>
      <button id="continuarOrdemServico"
              class="btn btn-sm btn-secondary"
              :disabled="!enableImpressao"
              @click="changeTelaOrdemServico">
        Continuar
      </button>
    </div>
  </div>
</template>

<script>
  //Services
  import CustasService from "@/services/Registros/CustasService"

  export default {
    name: "ImpressaoOrdemServico",
    props: {
      ordemServico: { type: [Array, Object], default: () => ({}) },
      propImprimirOs: {type: Object, default: () => ({})},
      propPedidoPendente: {type: Object, default: () => {}},
    },
    data () {
      return {
        emolumentos: null,
        selected: null,
        custas: [],
        enableImpressao: false
      }
    },
    watch: {
      propImprimirOs () {
        this.selectOrdemServico(this.propImprimirOs)
        this.changeTelaOrdemServico()
      },
      ordemServico () {
        this.selectFirstOS()
        this.enableImpressao = true
      },
      selected () {
        if (!this.selected) {
          this.emolumentos = null
          this.$emit('onSelectOrdemServico', this.emolumentos, this.selected)
        }
      }
    },
    mounted () {
      this.getCustas()
    },
    methods: {
      filterItensBySelo (itens) {
        return itens.filter(item => !item.flag_cancelado)
      },
      async selectOrdemServico ($event) {
        if (!$event) return

        if (this.selected === $event) {
          this.selected = null
          return
        }

        this.selected = $event


        if (this.custas && this.custas.length == 0) {
          await this.getCustas()
        }

        let emolumentos = [{
          destino: 'Total',
          valor: this.centsToReal($event.valor_total)
        }]

        let itens = []
        let valorAverbacao = 0
        
        $event.itens.map(item => {
          if (!item.flag_cancelado) {
            const quantidade = item.quantidade
            item.custa.itens.map((custa_item, index) => {
              itens[index] = {
                destino: custa_item.destino,
                valor: itens[index] ? itens[index].valor + (custa_item.valor * quantidade) : custa_item.valor * quantidade
              }
            })
          }

          const custaAverbacao = this.custas.find(custa => custa.codigo === 12 && custa.custa_info_iss_id == item.custa.custa_info_iss_id)

          if (item.averbacao && custaAverbacao) {     
            const quantidadeAverbacao = item.averbacao
            itens.map(item => {
              const custaItem = custaAverbacao.itens.filter(custa => custa.destino == item.destino)
              valorAverbacao = custaItem[0].valor * quantidadeAverbacao
              item.valor += +valorAverbacao
            })
          }
        })

        itens.map(item => {
          item.valor = this.centsToReal(item.valor)
        })

        itens.push(...emolumentos)

        this.emolumentos = itens


        this.$emit('onSelectOrdemServico', this.emolumentos, this.selected)
      },
      centsToReal (cents) {
        return (cents / 100).toLocaleString("pt-BR", {style: "currency", currency: "brl"})
      },
      changeTelaOrdemServico () {
        const emolumentos = this.emolumentos || false
        this.$emit('OnChangeTelaOrdemServico', emolumentos)
      },
      async selectLastOS () {
        await this.selectOrdemServico(this.ordemServico[this.ordemServico.length - 1])
        this.selected = this.ordemServico[this.ordemServico.length - 1]
      },
      async selectFirstOS () {
        await this.selectOrdemServico(this.ordemServico[0])
        this.selected = this.ordemServico[0]
      },


      async getCustas () {
        loader({ active: true })
        const custas = await CustasService.getCustas({
          cartorio_id: this.$store.state.auth.cartorio_id,
          perPage: 100,
          tipo: 'REGISTRO_CIVIL',
          os: 1,
          ativo: true
        })
        this.custas = custas.data
        loader({ active: false })
      },
    }
  }
</script>

<style scoped>

</style>
